import {restoreLead} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../lead-keys";

export function restoreLeadMutationOptions() {
  return mutationOptions({
    mutationFn: (id: string) => restoreLead(id),
    mutationKey: leadMutationKeys.restoreLead,
    onSuccess: async (_data, id, _context, {client}) => {
      client.removeQueries({queryKey: leadKeys.detail(id)});
      await client.invalidateQueries({queryKey: leadKeys.lists()});
    },
  });
}
